import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { Box, Collapse, FormLabel, GridLegacy, MenuItem, TextField, Typography } from "@mui/material";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import React from "react";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import { useController, useWatch } from "react-hook-form";
import { connect } from "react-redux";
import FormFieldTwoColumns from "../../../components/Forms/Layouts/FormFieldTwoColumns";
import FormFile from "../../../components/Forms/FormFile";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import { ImageResolutionHint } from "../../../components/ImageHints/ImageResolutionHint";
import TextFieldCurrency from "../../../../../Components/TextFieldCurrency";
import { DateTimePicker } from "@mui/x-date-pickers";
import { format, parse } from "date-fns";

function General(props) {
  const type = useWatch({ name: "type" });

  const {
    field: { value: customData, onChange: customDataOnChange },
  } = useController({ name: "custom_data" });

  const {
    field: { value: startDateTime, onChange: startDateTimeOnChange },
  } = useController({ name: "start_date_time" });

  const {
    field: { value: endDateTime, onChange: endDateTimeOnChange },
  } = useController({ name: "end_date_time" });
  console.log(
    !startDateTime || startDateTime === "0000-00-00 00:00:00"
      ? null
      : parse(startDateTime, "yyyy-MM-dd HH:mm:ss", new Date())
  );
  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <GridLegacy item xs={12}>
            <GridLegacy container spacing={1}>
              <FormTextTC name={"name"} tDefault={"Campaign name"} tKey={"campaigns.name"} />
            </GridLegacy>
            <GridLegacy container spacing={1}>
              <FormSelectTC
                name={"type"}
                options={[
                  <MenuItem key={"X_FOR_Y"} value={"X_FOR_Y"}>
                    X_FOR_Y
                  </MenuItem>,
                  <MenuItem key={"BUY_X_PAY_Y"} value={"BUY_X_PAY_Y"}>
                    BUY_X_PAY_Y
                  </MenuItem>,
                  <MenuItem key={"X_PERCENTAGE_OFF"} value={"X_PERCENTAGE_OFF"}>
                    X_PERCENTAGE_OFF
                  </MenuItem>,
                  <MenuItem key={"XTH_ITEM_Y_PERCENTAGE_OFF"} value={"XTH_ITEM_Y_PERCENTAGE_OFF"}>
                    XTH_ITEM_Y_PERCENTAGE_OFF
                  </MenuItem>,
                  <MenuItem key={"X_PER_GROUP_FOR_Y"} value={"X_PER_GROUP_FOR_Y"}>
                    X_PER_GROUP_FOR_Y
                  </MenuItem>,
                  <MenuItem key={"NONE"} value={"NONE"}>
                    NONE
                  </MenuItem>,
                ]}
                size={"small"}
                tDefault={"Campaign type"}
                tKey={"campaigns.type"}
                variant={"standard"}
              />
              <Box sx={{ width: 1 }}>
                <Typography sx={{ mb: 2 }}>
                  {type === "X_FOR_Y"
                    ? "X products for Y euros"
                    : type === "BUY_X_PAY_Y"
                      ? "Get X products and pay Y products"
                      : type === "XTH_ITEM_Y_PERCENTAGE_OFF"
                        ? "Xth item gets Y percentage discount"
                        : type === "X_PER_GROUP_FOR_Y"
                          ? "Get X number of items per group for Y euros"
                          : null}
                </Typography>
              </Box>
              <Box sx={{ width: 1 }}>
                <Collapse in={type === "X_FOR_Y" || type === "BUY_X_PAY_Y" || type === "XTH_ITEM_Y_PERCENTAGE_OFF"}>
                  <Box>
                    <TextField
                      label={"X"}
                      onChange={(e) => {
                        const newValue = [...(customData ?? [])];
                        console.log(e.target.value);
                        console.log(newValue);
                        newValue[0] = Number(e.target.value);
                        console.log(newValue);
                        customDataOnChange(newValue);
                      }}
                      type={"number"}
                      value={customData?.[0] ?? 0}
                    />
                    <TextField
                      label={"Y"}
                      onChange={(e) => {
                        const newValue = [...(customData ?? [])];
                        newValue[1] = Number(e.target.value);
                        customDataOnChange(newValue);
                      }}
                      type={"number"}
                      value={customData?.[1] ?? 0}
                    />
                  </Box>
                </Collapse>
              </Box>
              <Box sx={{ width: 1 }}>
                <Collapse in={type === "X_PERCENTAGE_OFF"}>
                  <Box>
                    <TextField
                      label={"X"}
                      onChange={(e) => {
                        const newValue = [...(customData ?? [])];
                        newValue[0] = Number(e.target.value);
                        customDataOnChange(newValue);
                      }}
                      type={"number"}
                      value={customData?.[0] ?? 0}
                    />
                  </Box>
                </Collapse>
              </Box>
              <Box sx={{ width: 1 }}>
                <Collapse in={type === "X_PER_GROUP_FOR_Y"}>
                  <Box>
                    <TextFieldCurrency
                      onChange={(value) => {
                        const newValue = [...(customData ?? [])];
                        newValue[0] = value;
                        customDataOnChange(newValue);
                      }}
                      value={customData?.[0] ?? 0}
                    />
                  </Box>
                </Collapse>
              </Box>
              <FormSwitchTC
                name={"is_active_in_jamezz"}
                tDefault={"Is visible in Jamezz"}
                tKey={"campaigns.is_active_in_jamezz"}
              />
              <FormSwitchTC
                name={"is_active_in_pos"}
                tDefault={"Is visible in POS"}
                tKey={"campaigns.is_active_in_pos"}
              />
              <FormFieldTwoColumns
                gridSizes={{ column1: { xs: 4 }, column2: { xs: 8 } }}
                tDefault={"Start date & time"}
                tKey={"Start time"}
              >
                <DateTimePicker
                  closeOnSelect
                  onChange={(date) => startDateTimeOnChange(date == null ? date : format(date, "yyyy-MM-dd HH:mm:ss"))}
                  slotProps={{
                    field: { clearable: true, onClear: () => startDateTimeOnChange(null) },
                  }}
                  value={
                    !startDateTime || startDateTime === "0000-00-00 00:00:00"
                      ? null
                      : parse(startDateTime, "yyyy-MM-dd HH:mm:ss", new Date())
                  }
                />
              </FormFieldTwoColumns>
              <FormFieldTwoColumns
                gridSizes={{ column1: { xs: 4 }, column2: { xs: 8 } }}
                tDefault={"End date & time"}
                tKey={"End time"}
              >
                <DateTimePicker
                  closeOnSelect
                  onChange={(date) => endDateTimeOnChange(date == null ? date : format(date, "yyyy-MM-dd HH:mm:ss"))}
                  slotProps={{
                    field: { clearable: true, onClear: () => endDateTimeOnChange(null) },
                  }}
                  value={
                    !endDateTime || endDateTime === "0000-00-00 00:00:00"
                      ? null
                      : parse(endDateTime, "yyyy-MM-dd HH:mm:ss", new Date())
                  }
                />
              </FormFieldTwoColumns>
              <GridLegacy item sm={4} xs={12}>
                <FormLabel>
                  <TranslationWrapper tDefault={"Afbeelding"} tKey={"menukaarten.form.afbeelding.label.afbeelding"} />
                </FormLabel>
                <ImageResolutionHint res={"300x300"} />
              </GridLegacy>
              <GridLegacy item sm={8} xs={12}>
                <FormFile canCrop={true} name={"imgid"} nullable={true} type={"image"} />
              </GridLegacy>
            </GridLegacy>
          </GridLegacy>
        </GridLegacy>
      </CardBody>
    </Card>
  );
}

const mapStateToProps = (state) => {
  return {
    userLocale: state.user.lang,
  };
};

export default connect(mapStateToProps)(General);
